import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import {
    clearAuthSession,
    emptyAuthState,
    loadAuthFromSession,
} from "../helperData/panelRoutes";

export const GlobalStateContext = React.createContext(null);

const GlobalStates = ({ ...props }) => {
    const [currentPanel, setCurrentPanel] = useState("user");
    const { t } = useTranslation();
    const [refreshNewCount, setRefreshNewCount] = useState(false);
    const [sidebarActiveItem, setSidebarActiveItem] = useState({
        id: "1",
        title: t("Dashboard.label"),
        iconName: "dashboardIcon",
        addressLink: "/dashboard",
    });
    const [toggleSidebar, setToggleSidebar] = useState(false);
    const [editablefiled, setEditablefiled] = useState({
        status: false,
        number: 0,
        change: false,
        item: {},
    });
    const [auth, setAuth] = useState(() => {
        const stored = loadAuthFromSession();
        if (!stored) {
            clearAuthSession();
            return emptyAuthState();
        }
        return stored;
    });

    const feedbackAppGlobalState = useState({
        data: {
            first_name: "",
            last_name: "",
            score: 0,
            phone_number: "",
            criteria_replies: [],
            form: 0,
            item: 0,
            company: 0,
            features: [],
        },
        ajax: {},
        productId: "",
        username: "",
    });

    useEffect(() => {
        Cookies.remove("login_info");

        const storedUsername =
            sessionStorage.getItem("username") ||
            localStorage.getItem("username");
        if (storedUsername) {
            feedbackAppGlobalState[1]((prev) => ({
                ...prev,
                username: storedUsername,
            }));
        }
    }, []);

    const [panelType, setPanelType] = useState({
        id: "2",
        title: t("Corpration.Panel.label"),
        type: "organ",
    });

    return (
        <GlobalStateContext.Provider
            value={{
                currentPanel,
                setCurrentPanel,
                panelType,
                setPanelType,
                sidebarActiveItem,
                setSidebarActiveItem,
                auth,
                setAuth,
                toggleSidebar,
                setToggleSidebar,
                editablefiled,
                setEditablefiled,
                refreshNewCount,
                setRefreshNewCount,
                feedbackAppGlobalState,
            }}
        >
            {props.children}
        </GlobalStateContext.Provider>
    );
};

export default GlobalStates;
